/* eslint-disable react/prop-types */ // TODO: add props
import { Component, Fragment } from 'react';
import { withAnalytics } from 'edrolo/analytics';
import SystemFailure from '../SystemFailure';
import AppContainer from '../AppContainer';

// PageErrorBoundary catches an error and renders a full page with a
// SystemError. It allows for navigation within the react-router context by
// only rendering the failure page at the location where an error last occurred.
// It should be used to wrap whole pages only. Page components can be wrapped
// with edrolo/domains/app/components/hoc.pageErrorBoundaryHoc

@withAnalytics
export default class PageErrorBoundary extends Component {
  // We record the url the error occurred on, so that navigation between pages
  // with the same component will work. (e.g. if one class fails,
  // we can click back to a different class without triggering the boundary)
  state = { errHref: null };

  static getDerivedStateFromError() {
    return { errHref: window.location.href };
  }

  componentDidCatch(err, errInfo) {
    global.Sentry?.captureException(err, {
      tags: {
        hitPageErrorBoundary: true,
        windowLocation: window.location.href,
      },
    });

    this.props.analytics.track('page error boundary showed', {
      error_message: err?.message,
      error_info: errInfo,
    });
  }

  render() {
    if (this.state.errHref && this.state.errHref === window.location.href) {
      return (
        <AppContainer>
          <SystemFailure />
        </AppContainer>
      );
    }

    return <Fragment>{this.props.children}</Fragment>;
  }
}
